import {Container, Graphics, Rectangle, Text} from "pixi.js";
import {MAX_VOLUME} from "./assets.js";
import {Vector} from "./i.js";
import {keyboard, Keyboard} from "./i.js";
import {UIUtils, Clicker} from "./i.js";
import {Button} from "./i.js";

export class Pauser {
	constructor(game) {
		this.game = game;

		// Can be read / written from outside
		this.gamePaused = false;

		this.display = new Container();

		this._displayUnpaused = new Container();
		this._displayPaused = new Container();
		this.display.addChild(this._displayUnpaused, this._displayPaused);

		this._pauseButton = new Graphics();
		this._pauseClicker = new Clicker(this._pauseButton);
		this._displayUnpaused.addChild(this._pauseButton);

		this._background = new Graphics();
		this._title = new Text({text: "Time stop", style: UIUtils.getFont(0xffffff)});
		this._continue = new Button(game.unicenter);
		this._adjustSoundVolume = new Button(game.unicenter);
		this._adjustMusicVolume = new Button(game.unicenter);

		this._displayPaused.addChild(
			this._background,
			this._title,
			this._continue,
			this._adjustSoundVolume,
			this._adjustMusicVolume
		);

		keyboard.pushControl(new Keyboard.Control(
			"PAUSER",
			new Map([
				[".PAUSE", "PAUSE_GAME"]
			]),
			new Set()
		));
	}

	update(screenSize) {
		if (keyboard.getActions("PAUSER").has("PAUSE_GAME")) {
			this.gamePaused = !this.gamePaused;
		}

		if (this._pauseClicker.wasClicked()) this.gamePaused = true;
		if (this._continue.wasClicked()) this.gamePaused = false;

		let rulerLength = UIUtils.getRulerLength(screenSize);

		if (this.gamePaused) {
			if (this._adjustSoundVolume.wasClicked()) {
				this.game.sound.setVolume("sound",
					(this.game.sound.getVolume("sound") + 1) % (MAX_VOLUME + 1)
				);
			}
			if (this._adjustMusicVolume.wasClicked()) {
				this.game.sound.setVolume("music",
					(this.game.sound.getVolume("music") + 1) % (MAX_VOLUME + 1)
				);
			}

			this._displayUnpaused.visible = false;
			this._displayPaused.visible = true;

			this._background
				.clear()
				.rect(
					0, 0,
					screenSize.x, screenSize.y
				)
				.fill({color: 0x061406, alpha: 0.85});

			this._title.style.fontSize = 0.05 * rulerLength;
			let titleOrigin = new Vector(
				(screenSize.x - this._title.width) / 2,
				1 / 3 * screenSize.y
			).round();
			this._title.position.copyFrom(titleOrigin);

			let continueSize = new Vector(0.25 * rulerLength, 0.1 * rulerLength).round();
			let continueOrigin = new Vector(
				(screenSize.x - continueSize.x) / 2,
				screenSize.y / 2
			).round();
			this._continue.update(
				0x001100, 0xffffff,
				continueOrigin, continueSize,
				"Continue"
			);

			let volumeSize = new Vector(continueSize.x, 0.5 * continueSize.y).round();
			let volumeOrigin = new Vector(
				continueOrigin.x,
				continueOrigin.y + continueSize.y + 0.1 * rulerLength
			).round();
			let currentSoundVolume = this.game.sound.getVolume("sound");
			this._adjustSoundVolume.update(
				0x001100, 0xffffff,
				volumeOrigin, volumeSize,
				`Sound volume: ${currentSoundVolume > 0 ? currentSoundVolume : "off"}`
			);
			volumeOrigin.y += volumeSize.y + Math.round(0.01 * rulerLength);
			let currentMusicVolume = this.game.sound.getVolume("music");
			this._adjustMusicVolume.update(
				0x001100, 0xffffff,
				volumeOrigin, volumeSize,
				`Music volume: ${currentMusicVolume > 0 ? currentMusicVolume : "off"}`
			);
		} else {
			this._displayPaused.visible = false;
			this._displayUnpaused.visible = true;

			let pauseButtonOrigin = new Vector(
				0.02 * rulerLength,
				0.02 * rulerLength
			).round();
			let barWidth = Math.round(0.01 * rulerLength);
			this._pauseButton.position.copyFrom(pauseButtonOrigin);
			this._pauseButton
				.clear()
				.rect(0, 0, barWidth, 3 * barWidth)
				.rect(2 * barWidth, 0, barWidth, 3 * barWidth)
				.fill(0xbbffbb);
			this._pauseButton.hitArea = new Rectangle(0, 0, 3 * barWidth, 3 * barWidth);
		}

		this._pauseClicker.clearStuff();
		this._continue.clearStuff();
		this._adjustSoundVolume.clearStuff();
		this._adjustMusicVolume.clearStuff();
	}
}
